export const contentContainer =
  'mx-auto w-[min(1660px,100%)] px-24 md:px-32 lg:px-56'
